var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"type":"warning","value":true}},[_vm._v("Keine Berechtigung")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }